<template>
    <span class="whitespace-nowrap rounded-lg bg-primary-600 px-2 py-px text-white">
        <slot />
    </span>
</template>
